<template>
  <div>
    <div class="admissions_btn" v-if="HomeData && HomeData.Admissions_Year && HomeData.Admissions_Url">
      <a :href="HomeData.Admissions_Url" :title="HomeData.Admissions_Year + $t('學年度') + $t('招生資訊')">
        <p>
          <span>{{ HomeData.Admissions_Year }}{{ $t('學年度') }}</span>
          <span>{{ $t('招生資訊') }}</span>
        </p>
      </a>
    </div>
    <div class="wrapper home">
      <!-- 背景線條 -->
      <img class="bg_line" src="img/bg_line.svg" alt="">
      <!-- 背景碎片動畫1 -->
      <div class="bg_box">
        <div class="fragments_1 fragments_box">
          <img class="fragments front" src="img/fragments_1.png" alt="">
          <img class="fragments back" src="img/fragments_1_b.png" alt="">
        </div>
        <div class="fragments_2 fragments_box">
          <img class="fragments front" src="img/fragments_2.png" alt="">
          <img class="fragments back" src="img/fragments_2_g.png" alt="">
        </div>
        <div class="fragments_3 fragments_box">
          <img class="fragments front" src="img/fragments_3.png" alt="">
          <img class="fragments back" src="img/fragments_3_g.png" alt="">
        </div>
        <div class="fragments_4 fragments_box">
          <img class="fragments front" src="img/fragments_4.png" alt="">
          <img class="fragments back" src="img/fragments_4_b.png" alt="">
        </div>
        <div class="fragments_5 fragments_box">
          <img class="fragments front" src="img/fragments_5.png" alt="">
          <img class="fragments back" src="img/fragments_5_b.png" alt="">
        </div>
        <div class="fragments_6 fragments_box">
          <img class="fragments front" src="img/fragments_6.png" alt="">
          <img class="fragments back" src="img/fragments_6_g.png" alt="">
        </div>
        <div class="fragments_7 fragments_box">
          <img class="fragments front" src="img/fragments_7.png" alt="">
          <img class="fragments back" src="img/fragments_7_g.png" alt="">
        </div>
      </div>
      <!-- 背景碎片動畫2 -->
      <div class="bg_box bg_box2">
        <div class="fragments_1 fragments_box">
          <img class="fragments front" src="img/fragments_1.png" alt="">
          <img class="fragments back" src="img/fragments_1_b.png" alt="">
        </div>
        <div class="fragments_2 fragments_box">
          <img class="fragments front" src="img/fragments_2.png" alt="">
          <img class="fragments back" src="img/fragments_2_g.png" alt="">
        </div>
        <div class="fragments_3 fragments_box">
          <img class="fragments front" src="img/fragments_3.png" alt="">
          <img class="fragments back" src="img/fragments_3_g.png" alt="">
        </div>
        <div class="fragments_4 fragments_box">
          <img class="fragments front" src="img/fragments_4.png" alt="">
          <img class="fragments back" src="img/fragments_4_b.png" alt="">
        </div>
        <div class="fragments_5 fragments_box">
          <img class="fragments front" src="img/fragments_5.png" alt="">
          <img class="fragments back" src="img/fragments_5_b.png" alt="">
        </div>
        <div class="fragments_6 fragments_box">
          <img class="fragments front" src="img/fragments_6.png" alt="">
          <img class="fragments back" src="img/fragments_6_g.png" alt="">
        </div>
        <div class="fragments_7 fragments_box">
          <img class="fragments front" src="img/fragments_7.png" alt="">
          <img class="fragments back" src="img/fragments_7_g.png" alt="">
        </div>
      </div>
      <!-- banner -->
      <section class="banner" v-if="HomeData && HomeData.Banner_Category">
        <div class="container-fluid">
          <slick class="carousel_box" :options="{
            dots: true,
            autoplay: true,
            autoplaySpeed: 8000,
          }">
            <div class="box" v-for="Post in HomeData.Banner_Category.Posts">
              <div class="img_box">
                <img :src="HomeData.SiteUrl + Post.Image" alt="">
              </div>
              <div class="title">
                <a href="javascript:void(0)" @click="gotoPost(Post)" :title="Post.Title">
                  <div class="container">
                    <p>{{ Post.Title }}</p>
                  </div>
                </a>
              </div>
            </div>
          </slick>
        </div>
      </section>
      <section class="news" v-if="HomeData && HomeData.News_Category">
        <div class="container">
          <div class="title_box">
            <h2>{{ HomeData.News_Category.Category.CategoryName }}</h2>
            <div class="more_btn">
              <button class="more" @click="gotoCategoryByCId(HomeData.News_Category.Category.CId)">{{ $t('查看更多')
                }}</button>
            </div>
          </div>
          <div class="box">
            <div class="main_box" v-if="HomeData.News_Category.Posts.length >= 1">
              <div class="main">
                <a href="javascript:void(0)" @click="gotoPost(HomeData.News_Category.Posts[0])">
                  <div class="img_box">
                    <img v-if="HomeData.News_Category.Posts[0].Image"
                      :src="HomeData.SiteUrl + HomeData.News_Category.Posts[0].Image">
                    <img v-else src="img/default.png" alt="">
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ HomeData.News_Category.Posts[0].PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <h3>{{ HomeData.News_Category.Posts[0].Title }}</h3>
                    <div class="bg"></div>
                  </div>
                </a>
              </div>
            </div>
            <div class="main_box" v-if="HomeData.News_Category.Posts.length >= 2">
              <div class="main" v-if="HomeData.News_Category.Posts.length >= 2">
                <a href="javascript:void(0)" @click="gotoPost(HomeData.News_Category.Posts[1])">
                  <div class="img_box">
                    <img v-if="HomeData.News_Category.Posts[1].Image"
                      :src="HomeData.SiteUrl + HomeData.News_Category.Posts[1].Image">
                    <img v-else src="img/default.png" alt="">
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ HomeData.News_Category.Posts[1].PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <h3>{{ HomeData.News_Category.Posts[1].Title }}</h3>
                    <div class="bg"></div>
                  </div>
                </a>
              </div>
              <div class="main" v-if="HomeData.News_Category.Posts.length >= 3">
                <a href="javascript:void(0)" @click="gotoPost(HomeData.News_Category.Posts[2])">
                  <div class="img_box">
                    <img v-if="HomeData.News_Category.Posts[2].Image"
                      :src="HomeData.SiteUrl + HomeData.News_Category.Posts[2].Image">
                    <img v-else src="img/default.png" alt="">
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ HomeData.News_Category.Posts[2].PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <h3>{{ HomeData.News_Category.Posts[2].Title }}</h3>
                    <div class="bg"></div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="activity" v-if="HomeData && HomeData.DE_Category">
        <div class="container">
          <div class="title_box title_box_b">
            <h2>{{ HomeData.DE_Category.Category.CategoryName }}</h2>
            <div class="more_btn">
              <button class="more" @click="gotoCategoryByCId(HomeData.DE_Category.Category.CId)">{{ $t('查看更多')
                }}</button>
            </div>
          </div>
          <div class="box">
            <div class="photo">
              <div class="img_box">
                <!-- <img class="show" src="img/img_1.png" alt="">
                <img src="img/img_2.png" alt="">
                <img src="img/img_3.png" alt=""> -->
                <template v-for="(Post, index) in HomeData.DE_Category.Posts">
                  <img :class="index == 0 ? 'show' : ''" v-if="Post.Image" :src="HomeData.SiteUrl + Post.Image">
                  <img :class="index == 0 ? 'show' : ''" v-else src="img/default.png" alt="">
                </template>
              </div>
            </div>
            <ul class="list">
              <li class="text" v-for="(Post, index) in HomeData.DE_Category.Posts">
                <a href="javascript:void(0)" @click="gotoPost(Post)" :class="index == 0 ? 'add' : ''">
                  <div class="time">
                    <div class="rectangle_bg">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                  </div>
                  <p>{{ Post.Title }}</p>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="carousel_two" v-if="HomeData">
        <div class="container">
          <div class="box" v-if="HomeData.IUC_Category">
            <div class="title_box">
              <h2>{{ HomeData.IUC_Category.Category.CategoryName }}</h2>
              <div class="more_btn">
                <button class="more" @click="gotoCategoryByCId(HomeData.IUC_Category.Category.CId)">{{ $t('查看更多')
                  }}</button>
              </div>
            </div>
            <slick class="carousel carousel_1" :options="{
              dots: true,
              autoplay: true,
              autoplaySpeed: 8000,
            }">
              <div class="" v-for="Post in HomeData.IUC_Category.Posts">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="img_box">
                    <img v-if="Post.Image" :src="HomeData.SiteUrl + Post.Image">
                    <img v-else src="img/default.png" alt="">
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <h3>{{ Post.Title }}</h3>
                  </div>
                </a>
              </div>
            </slick>
          </div>
          <div class="box" v-if="HomeData.IA_Category">
            <div class="title_box title_box_b">
              <h2>{{ HomeData.IA_Category.Category.CategoryName }}</h2>
              <div class="more_btn">
                <button class="more" @click="gotoCategoryByCId(HomeData.IA_Category.Category.CId)">{{ $t('查看更多')
                  }}</button>
              </div>
            </div>
            <slick class="carousel carousel_2" :options="{
              dots: true,
              autoplay: true,
              autoplaySpeed: 8000,
            }">
              <div class="" v-for="Post in HomeData.IA_Category.Posts">
                <a href="javascript:void(0)" @click="gotoPost(Post)">
                  <div class="img_box">
                    <img v-if="Post.Image" :src="HomeData.SiteUrl + Post.Image">
                    <img v-else src="img/default.png" alt="">
                  </div>
                  <div class="text">
                    <div class="time">
                      <div class="rectangle_bg">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                      <p>{{ Post.PublicStartTime | timeString("YYYY/MM/DD") }}</p>
                    </div>
                    <h3>{{ Post.Title }}</h3>
                  </div>
                </a>
              </div>
            </slick>
          </div>
        </div>
      </section>
      <section class="video" v-if="HomeData && HomeData.Video_Category && VideoIds.length >= 3">
        <div class="container">
          <div class="title_box title_box_b">
            <h2>{{ HomeData.Video_Category.Category.CategoryName }}</h2>
            <div class="more_btn">
              <button class="more" @click="gotoCategoryByCId(HomeData.Video_Category.Category.CId)">{{ $t('查看更多')
                }}</button>
            </div>
          </div>
          <div class="box">
            <div class="video_list">
              <div class="iframe_box">
                <iframe width="" height="" :src="'https://www.youtube.com/embed/' + VideoIds[1]"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe>
              </div>
              <div class="iframe_box">
                <iframe width="" height="" :src="'https://www.youtube.com/embed/' + VideoIds[2]"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe>
              </div>
              <div class="bg"></div>
            </div>
            <div class="video_main">
              <div class="iframe_box">
                <iframe width="" height="" :src="'https://www.youtube.com/embed/' + VideoIds[0]"
                  title="YouTube video player" frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="testimonials_box" v-if="HomeData && HomeData.Recommend_Category">
        <div class="container">
          <div class="title_box">
            <h2>{{ HomeData.Recommend_Category.Category.CategoryName }}</h2>
            <div class="more_btn">
              <button class="more" @click="gotoCategoryByCId(HomeData.Recommend_Category.Category.CId)">{{ $t('查看更多')
                }}</button>
            </div>
          </div>

          <slick class="recommend_carousel" :options="{
            dots: true,
            autoplay: true,
            autoplaySpeed: 8000,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 991.98,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 575.98,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
          }">
            <div class="box" v-for="Post in HomeData.Recommend_Category.Posts">
              <a href="javascript:void(0)" @click="gotoPost(Post)">
                <div class="img_box">
                  <img v-if="Post.Image" :src="HomeData.SiteUrl + Post.Image">
                  <img v-else src="img/default.png" alt="">
                </div>
              </a>
            </div>
          </slick>
        </div>
      </section>

    </div><!-- wrapper -->
  </div>
</template>
<script>
import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

const messages = {
  zh_tw: {
    "學年度": "學年度",
    "招生資訊": "招生資訊",
    "查看更多": "查看更多",
  },
  en: {
    "學年度": "",
    "招生資訊": "Admissions",
    "查看更多": "MORE",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

import Slick from "vue-slick";

export default {
  name: "Home",
  i18n,
  components: {
    Slick,
  },
  data() {
    return {
      HomeData: {},
      VideoIds: [],
      currentIndex: 0,
      totalImages: 0,
      intervalId: 0,
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/GCIT/Home",
        {
          params: {
            lang: $cookies.get("gcit_the_site_lang")
          },
        }
      )
      .then((response) => {
        this.HomeData = response.data;
        let that = this;
        if (this.HomeData.Video_Category.Posts.length >= 1) {
          $.each(this.HomeData.Video_Category.Posts, function (index, value) {
            var YoutubeId = '';
            if (value.YoutubeUrl.indexOf("http://youtu.be/") >= 0) {
              //影片縮網址
              YoutubeId = value.YoutubeUrl.replace("http://youtu.be/", "");
            } else if (value.YoutubeUrl.indexOf("https://youtu.be/") >= 0) {
              //影片縮網址
              YoutubeId = value.YoutubeUrl.replace("https://youtu.be/", "");
            } else {
              var QueryStringIndex = value.YoutubeUrl.indexOf("?v=") + 3;
              var QueryString = value.YoutubeUrl.substring(QueryStringIndex);
              var Index = QueryString.indexOf('&');
              YoutubeId = QueryString;
              if (Index > 0) //若&存在的話
              { YoutubeId = QueryString.substring(0, Index); }
              if (YoutubeId.indexOf("?") > 0) { YoutubeId = YoutubeId.substring(0, YoutubeId.indexOf("?")); }
            }
            that.VideoIds.push(YoutubeId);
          });
        }
        Promise.all(Array.from(document.images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => img.addEventListener('load', resolve));
        })).then(() => {
          setTimeout(() => {
            // 首頁動畫
            $("html body").scroll(function () {
              var N = $("html body").scrollTop();
              // 首頁 視差滾動 
              $('.bg_line').css('transform', 'translatex(' + (N * -0.3) + 'px)' + 'translatey(' + (N * 0.3) + 'px)');
            });
            // 首頁 banner 的點點按鈕
            $(document).ready(function () {
              var windowWidth = $(window).width();
              if (windowWidth > 991.98) {
                var marginRight = parseInt($('.banner .box .title .container').css('margin-right'));
                var paddingRight = parseInt($('.banner .box .title .container').css('padding-right'));
                var totalRight = marginRight + paddingRight;
                $('.banner .slick-dots').css('padding-right', totalRight);
                var totalWidth = 0;
                $('.banner .slick-dots li').each(function () {
                  totalWidth += $(this).outerWidth(true);
                });
                $('.banner .box .title p').css('margin-right', totalWidth);
              }
            });
            that.init();
          }, 0);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    if ($cookies.isKey("gcit_the_site_lang")) {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = $cookies.get("gcit_the_site_lang");
    } else {
      i18n.locale = $cookies.get("gcit_the_site_lang");
      this.local = "zh_tw";
    }
  },
  updated: function () {
  },
  methods: {
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Blank) {
          window.open(Post.Url, "_blank");
        } else {
          location.href = Post.Url;
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
    gotoCategoryByCId: function (CId) {
      this.$router.push({
        name: "Category",
        params: { CId: CId },
      });
    },
    init() {
      let that = this;
      this.currentIndex = 0;
      this.totalImages = $('.activity .box .img_box img').length;
      $('.activity .box .list .text a').mouseenter(function () {
        clearInterval(that.intervalId);
        that.intervalId = null;
        $('.activity .box .list .text a').removeClass("add");
        $(this).addClass("add");
        var index = $(this).parent().index();
        $('.activity .box .img_box img').removeClass("show").eq(index).addClass('show');
        that.currentIndex = index;
      });
      $('.activity .box .list .text a').mouseleave(function () {
        that.startAutoSwitch();
      });
      this.startAutoSwitch();
    },
    autoSwitchImage() {
      this.currentIndex = (this.currentIndex + 1) % this.totalImages;
      $('.activity .box .list .text a').removeClass("add").eq(this.currentIndex).addClass("add");
      $('.activity .box .img_box img').removeClass("show").eq(this.currentIndex).addClass('show');
    },
    startAutoSwitch() {
      if (!this.intervalId) {
        this.intervalId = setInterval(this.autoSwitchImage, 5000);
      }
    },
  },
};
</script>
